import React, { useEffect, useState } from "react";
import {
  graphcms,
  QUERY_NEXT_EVENTS,
  QUERY_PREV_EVENTS,
} from "../Graphql/Queries";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Skeleton } from "@/components/ui/skeleton";

function Activities() {
  const [nextEvents, setNextEvents] = useState([]);
  const [prevEvents, setPrevEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      graphcms.request(QUERY_NEXT_EVENTS),
      graphcms.request(QUERY_PREV_EVENTS),
    ]).then(([nextRes, prevRes]) => {
      setNextEvents(nextRes.events);
      setPrevEvents(prevRes.events);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="h-auto my-16 mx-auto container">
        <div className="next-events my-16">
          <h2 className="text-3xl font-bold text-center mb-10 uppercase">
            Upcoming Events
          </h2>
          <div className="grid gap-10 grid-cols-fluid">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="card w-64 h-[25rem] bg-slate-50 mx-auto rounded-xl drop-shadow-xl overflow-hidden">
                <Skeleton className="w-64 h-64 rounded-t-xl" />
                <div className="p-4 space-y-2">
                  <Skeleton className="h-4 w-3/4 mx-auto" />
                  <Skeleton className="h-4 w-1/2 mx-auto" />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="prev-events mt-16 mb-32">
          <h2 className="text-3xl font-bold text-center mb-10 uppercase">
            Previous Events
          </h2>
          <div className="w-full grid gap-x-10 gap-y-16 grid-cols-fluid">
            {Array.from({ length: 8 }).map((_, i) => (
              <div
                key={i}
                className="card w-64 h-[25rem] bg-slate-50 mx-auto rounded-xl drop-shadow-xl overflow-hidden">
                <Skeleton className="w-64 h-64 rounded-t-xl" />
                <div className="p-4 space-y-2">
                  <Skeleton className="h-4 w-3/4 mx-auto" />
                  <Skeleton className="h-4 w-1/2 mx-auto" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Activities - IEEE CIS SBC UoJ</title>
        <meta
          name="description"
          content="Stay updated with the latest events, workshops, and seminars hosted by the IEEE CIS SBC at the University of Jaffna. Join us to enhance your skills and network with professionals."
        />
        <link rel="canonical" href="https://cis.jfn.ac.lk/activities" />
      </Helmet>
      <div className="h-auto my-16 mx-auto container">
        <div className="next-events my-16">
          <h2 className="text-3xl font-bold text-center mb-10 uppercase">
            Upcoming Events
          </h2>
          <div className="grid gap-10 grid-cols-fluid">
            {nextEvents.length === 0 && (
              <p className="text-base text-center text-neutral-500">
                There are no upcoming events.
              </p>
            )}
            {nextEvents?.map((event) => {
              return (
                <Link
                  to={`../event/${event.id}`}
                  key={event.id}
                  className="h-96">
                  <div className="card w-64 h-[25rem] bg-slate-50 mx-auto rounded-xl drop-shadow-xl overflow-hidden">
                    <img
                      className=" rounded-t-xl w-64 h-64 object-cover"
                      src={event.flyerImage.url}
                      alt={event.caption}
                    />
                    <div className="px-2 h-32 flex flex-col gap-y-2 justify-center ">
                      <h4 className="w-full text-center text-base font-semibold">
                        {event.caption}
                      </h4>
                      <p className="text-center text-sm truncate">
                        {event.keywords}
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
        <div className="prev-events mt-16 mb-32">
          <h2 className="text-3xl font-bold text-center mb-10 uppercase">
            Previous Events
          </h2>
          <div className="w-full grid gap-x-10 gap-y-16 grid-cols-fluid">
            {prevEvents?.map((event) => {
              return (
                <Link
                  to={`../event/${event.id}`}
                  className="h-96"
                  key={event.id}>
                  <div className="card w-64 h-[25rem] bg-slate-50 mx-auto rounded-xl drop-shadow-xl overflow-hidden">
                    <img
                      className=" rounded-t-xl w-64 h-64 object-cover"
                      src={event.flyerImage.url}
                      alt={event.caption}
                    />
                    <div className="px-2 h-32 flex flex-col gap-y-2 justify-center ">
                      <h4 className="w-full text-center text-base font-semibold">
                        {event.caption}
                      </h4>
                      <p className="text-center text-sm truncate">
                        {event.keywords}
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default Activities;
